import {
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  FormGroup,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useStepperContext } from "app/contexts/stepper";
import { useInscripcionContext } from "../../inscripcion-context";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { telefonoRegex } from "app/utils/regexps";

const initialState = {
  telefono_numero: "",
  telefono_principal: false,
};

function TelefonoForm({ telefono = initialState }) {
  const { addTelefono, updateTelefono, deleteTelefono } =
    useInscripcionContext();

  const [state, setState] = useState(telefono);
  const [isEditable] = useState(!!telefono.telefono_id);
  const [isEditing, setEditing] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!!isEditable && !isEditing) {
        return setEditing(true);
      } else if (!!isEditable && !!isEditing) {
        const isUpdated = updateTelefono({
          telefono: state,
        });

        if (isUpdated) {
          setEditing(false);

          return toast.success("¡Número de teléfono actualizado!");
        }
      } else {
        const isAdded = addTelefono({ telefono: state });

        if (isAdded) {
          setState(telefono);

          return toast.success("¡Número de teléfono agregado!");
        }
      }
    } catch (error) {
      console.log(error.message);

      return toast.error(error.message);
    }
  }

  function handleReset() {
    if (!!isEditable && !isEditing) {
      const isDeleted = deleteTelefono({ telefono_id: telefono.telefono_id });

      if (isDeleted) {
        return toast.success("¡Número de teléfono eliminado!");
      }
    } else if (!!isEditable && !!isEditing) {
      const isCanceled = window.confirm("¿Desea cancelar la edición?");

      if (isCanceled) {
        setState(telefono);

        return setEditing(false);
      }
    } else {
      const isReseted = window.confirm("¿Desea reiniciar el formulario?");

      if (isReseted) {
        setState(telefono);
      }
    }
  }

  return (
    <Paper
      component="form"
      className="animate__animated animate__slideInUp"
      onSubmit={handleSubmit}
      onReset={handleReset}
      variant="outlined"
    >
      <Grid container spacing={1} sx={{ padding: 2 }}>
        <Grid item xs={12}>
          <Typography variant="overline">
            <strong>{`${
              !!isEditable ? "Editar" : "Agregar"
            } número de teléfono`}</strong>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <TextField
            type="text"
            label="Número de teléfono"
            value={state.telefono_numero}
            onChange={(e) =>
              setState((state) => ({
                ...state,
                telefono_numero: e.target.value,
              }))
            }
            inputProps={{
              pattern: telefonoRegex.pattern,
              title: telefonoRegex.title,
            }}
            size="small"
            fullWidth
            required
            disabled={!!isEditable && !isEditing}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormGroup>
            <FormControlLabel
              disabled={!!isEditable && !isEditing}
              control={
                <Checkbox
                  checked={state.telefono_principal}
                  onChange={(e) =>
                    setState((state) => ({
                      ...state,
                      telefono_principal: e.target.checked,
                    }))
                  }
                />
              }
              label="¿Es un número de teléfono principal?"
            />
          </FormGroup>
        </Grid>

        <Grid item xs={12} md={6}>
          <Stack direction="row" justifyContent="end" spacing={1}>
            <Button
              type="submit"
              variant="contained"
              size="small"
              color={!!isEditable ? "warning" : "success"}
            >
              {!!isEditable && !isEditing
                ? "Editar"
                : !!isEditing
                ? "Actualizar"
                : "Agregar"}
            </Button>

            <Button
              type="reset"
              variant="outlined"
              size="small"
              color={!!isEditable && !isEditing ? "error" : "inherit"}
            >
              {!!isEditable && !isEditing
                ? "Eliminar"
                : !!isEditing
                ? "Cancelar"
                : "Reiniciar"}
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
}

export function Telefonos() {
  const stepper = useStepperContext();
  const { empresa } = useInscripcionContext();

  function handleNext() {
    try {
      if (!empresa.telefonos.length) {
        // throw new Error(
        //   "¡Por favor, agregue al menos un número de teléfono!"
        // );
      }

      return stepper.next();
    } catch (error) {
      return toast.error(error.message);
    }
  }

  return (
    <Stack spacing={2}>
      <Container maxWidth="sm">
        <Stack spacing={2}>
          {empresa.telefonos.map((telefono) => (
            <TelefonoForm key={telefono.telefono_id} telefono={telefono} />
          ))}

          <TelefonoForm />
        </Stack>
      </Container>

      <Stack
        direction="row"
        justifyContent="end"
        alignItems="center"
        spacing={1}
      >
        {!stepper.isFirstStep && (
          <Button variant="outlined" size="small" onClick={stepper.back}>
            Atrás
          </Button>
        )}

        <Button variant="contained" size="small" onClick={handleNext}>
          Siguiente
        </Button>
      </Stack>
    </Stack>
  );
}
